import { useEffect, useState } from "react";
import { fetchPrivacyInfo, deleteProfile } from "./api";

const Privacy = () => {
  const [privacyInfo, setPrivacyInfo] = useState([]);
  const [deleteId, setDeleteId] = useState("");

  useEffect(() => {
    const loadPrivacy = async () => {
      const data = await fetchPrivacyInfo();
      setPrivacyInfo(data || []);
    };
    loadPrivacy();
  }, []);

  const handleDelete = async () => {
    if (deleteId) {
      await deleteProfile(deleteId);
      alert(`Profile ${deleteId} deleted!`);
      setDeleteId("");
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">Privacy Management</h1>
      <div className="mt-4">
        <input
          type="text"
          placeholder="Enter Profile ID"
          className="border p-2 mr-2"
          value={deleteId}
          onChange={(e) => setDeleteId(e.target.value)}
        />
        <button onClick={handleDelete} className="bg-red-500 text-white px-4 py-2 rounded">
          Delete Profile
        </button>
      </div>
    </div>
  );
};

export default Privacy;
